import debounce from 'lodash.debounce';
// import ToggleScroll from 'utils/toggle-scroll';
interface MainNavProps {
    el: HTMLDivElement;
}

const DEBOUNCE_VALUE = 50;
const MAIN_NAV_ITEM_CLASS = 'main-nav-item';
const MAIN_NAV_ITEM_LINK_CLASS = 'main-nav-item-link';
const SUB_NAV_CLASS = 'sub-nav';
// const SUB_NAV_ITEM_CLASS = 'sub-nav-item';
// const SUB_NAV_ITEM_LINK_CLASS = 'sub-nav-item-link';
const MAIN_NAV_ACTIVE_CLASS = 'is-active';
const MAIN_NAV_DATA_TAG = '[data-main-nav]';
// const MEGA_MENU_CLASS = 'mega-menu';
const MEGA_MENU_MAIN_NAV_CLASS = 'mega-menu-main-nav';
// const MEGA_MENU_ITEM_CLASS = 'mega-menu-main-nav-item';
// const MEGA_MENU_ITEM_LINK_CLASS = 'mega-menu-main-nav-item-link';
const MEGA_MENU_ITEM_CLASS = 'mega-menu-main-nav-item';
const MEGA_MENU_ITEM_LINK_CLASS = 'mega-menu-main-nav-item-link';
const MEGA_MENU_SUB_NAV_CLASS = 'mega-menu-sub-nav';
const MEGA_MENU_SUB_NAV_ITEM_CLASS = 'mega-menu-sub-nav-item';
const MEGA_MENU_SUB_NAV_ITEM_LINK_CLASS = 'mega-menu-sub-nav-item-link';
const OUT_FOCUS_SELECTOR = '.header-logo-link, .desktop-search input'; // to close mega menu when focus on the next things.
const VISIBLE_SUB_NAV_CLASS = 'visible';


// To calculate height of Mega Menu Sub Nav Wrapper
function getHiddenHeight(el: HTMLDivElement): number {
    if (!el?.cloneNode) {
        return 0;
    }

    const clone = el.cloneNode(true) as HTMLDivElement;

    Object.assign(clone.style, {
        overflow: 'visible',
        height: 'auto',
        maxHeight: 'none',
        opacity: '0',
        visibility: 'hidden',
        display: 'block',
    });

    el.after(clone);
    const height = clone.offsetHeight;

    clone.remove();

    return height;
}

// Terms:
// 1st Level Menu: Main Nav
// 2nd Level Menu: Mega Menu Main Nav
// 3rd Level Menu: Mega Menu Sub Nav

// Expected behaviour:
// 1. Megamenu Desktop open CLICKED on the "Main Nav"
// 2. When Megamenu opened, the first menu from "Mega Menu Main Nav" is always opened at first (reason so there's no empty column)
// 3. When hover on other "Mega Menu Main Nav" it will open other sub menu
// 4. When the mouse is leaving "Mega Menu Main Nav" area it will stay open to the last opened sub nav, until mouse leave on the mega menu
// 5. When hover back on the "Main Nav" refer to number 2.

/* Re-enable when required
function isTouchEnabled(): boolean {
    return ('ontouchstart' in window) ||
        (navigator.maxTouchPoints > 0);
}
*/

function isHasSubmenu(el: HTMLElement): boolean {
    if (!el) {
        return false;
    }

    const subNav = el.querySelectorAll('.sub-nav');

    return subNav.length > 0;
}

const MainNav = ({ el }: MainNavProps): void => {
    const mainNavLinkEls = el.querySelectorAll(`.${MAIN_NAV_ITEM_LINK_CLASS}`);
    // const subNavLinkEls = el.querySelectorAll(`.${SUB_NAV_ITEM_LINK_CLASS}`);
    const megaMenuLinkEls = el.querySelectorAll(`.${MEGA_MENU_ITEM_LINK_CLASS}`);
    const megaMenuSubNavEls = el.querySelectorAll(`.${MEGA_MENU_SUB_NAV_CLASS}`);
    const megaMenuMainNavEls = el.querySelectorAll(`.${MEGA_MENU_MAIN_NAV_CLASS}`);
    const outFocusEls = document.querySelectorAll(OUT_FOCUS_SELECTOR);

    const closeOpenedMenu = (menuEl: HTMLElement): void => {
        menuEl.classList.remove(MAIN_NAV_ACTIVE_CLASS);
        menuEl.setAttribute('aria-expanded', 'false');
    };

    const closeAllMainNav = (): void => {
        mainNavLinkEls.forEach(mainNavLinkEl => {
            const parentEl = mainNavLinkEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
            if (!parentEl) {
                return;
            }

            closeOpenedMenu(parentEl as HTMLElement);
        });
    };

    const closeAllMegaMenuNav = (): void => {
        megaMenuLinkEls.forEach(megaMenuLinkEl => {
            const parentEl = megaMenuLinkEl.closest(`.${MEGA_MENU_ITEM_CLASS}`);
            if (!parentEl) {
                return;
            }

            closeOpenedMenu(parentEl as HTMLElement);
        });
    };

    const closeAllNav = (): void => {
        const allActiveMenus = el.querySelectorAll(`.${MAIN_NAV_ACTIVE_CLASS}`);
        allActiveMenus.forEach(allActiveMenu => {
            closeOpenedMenu(allActiveMenu as HTMLElement);
        });
    };

    const closeAllSubNav = (): void => {
        const allActiveSubNavs = el.querySelectorAll(`.${SUB_NAV_CLASS}`);
        allActiveSubNavs.forEach(allActiveSubNav => {
            allActiveSubNav.classList.remove(VISIBLE_SUB_NAV_CLASS);
        });
    };

    const openMegaMenuNav = (linkEl: HTMLElement): void => {
        const parentEl = linkEl.closest(`.${MEGA_MENU_ITEM_CLASS}`);
        if (!parentEl) {
            return;
        }

        parentEl.setAttribute('aria-expanded', 'true');
        parentEl.classList.add(MAIN_NAV_ACTIVE_CLASS);
    };

    // const openMainNav = (linkEl: HTMLElement, noAutoFocus?: boolean): void => {
    const openMainNav = (linkEl: HTMLElement): void => {
        // console.info('openMainNav');
        const parentEl = linkEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
        // console.info('parent el', parentEl);
        if (!parentEl) {
            return;
        }

        // const currentSubNavLinkEl = parentEl.querySelector(`.${SUB_NAV_ITEM_LINK_CLASS}`);
        // const currentMegaMenuLinkEl = parentEl.querySelector(`.${MEGA_MENU_ITEM_LINK_CLASS}`);

        // console.info('currentMegaMenuLinkEl', currentMegaMenuLinkEl);
        // // if (!currentSubNavLinkEl && !currentMegaMenuLinkEl) {
        // if (!currentMegaMenuLinkEl) {
        //     return;
        // }

        // const subNavEl = parentEl.querySelector(`.${SUB_NAV_CLASS}`);

        // subNavEl?.classList.add(VISIBLE_SUB_NAV_CLASS);

        parentEl.setAttribute('aria-expanded', 'true');
        parentEl.classList.add(MAIN_NAV_ACTIVE_CLASS);

        // const allActiveMenus = parentEl.querySelectorAll(`.sub-nav .${MAIN_NAV_ACTIVE_CLASS}`);
        // if there's 1 active menu then just return otherwise set the first menu as active
        // if (allActiveMenus.length) {
        //     return;
        // }

        // activate the first menu
        // currentMegaMenuLinkEl?.closest(`.${MEGA_MENU_ITEM_CLASS}`)?.classList.add(MAIN_NAV_ACTIVE_CLASS);

        // if (noAutoFocus) {
        //     return;
        // }

        // (currentSubNavLinkEl as HTMLAnchorElement)?.focus();
        // (currentMegaMenuLinkEl as HTMLAnchorElement)?.focus();
    };

    const closeMainNav = (linkEl: HTMLElement): void => {
        const parentEl = linkEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
        if (!parentEl) {
            return;
        }

        // const currentSubNavLinkEl = parentEl.querySelector(`.${SUB_NAV_ITEM_LINK_CLASS}`);
        // const currentMegaMenuLinkEl = parentEl.querySelector(`.${MEGA_MENU_ITEM_LINK_CLASS}`);
        // if (!currentSubNavLinkEl && !currentMegaMenuLinkEl) {
        //     return;
        // }

        parentEl.setAttribute('aria-expanded', 'false');
        parentEl.classList.remove(MAIN_NAV_ACTIVE_CLASS);
    };

    const focusNextElement = (parentEl: HTMLElement, focusElClass: string): void => {
        if (!parentEl.nextElementSibling) {
            return;
        }

        parentEl.classList.remove(MAIN_NAV_ACTIVE_CLASS);
        parentEl.setAttribute('aria-expanded', 'false');
        const nextLinkEl = parentEl.nextElementSibling.querySelector(`.${focusElClass}`);
        if (!nextLinkEl) {
            return;
        }

        (nextLinkEl as HTMLAnchorElement).focus();
        parentEl.nextElementSibling.classList.add(MAIN_NAV_ACTIVE_CLASS);
        parentEl.nextElementSibling.setAttribute('aria-expanded', 'true');
    };

    const focusPrevElement = (parentEl: HTMLElement, focusElClass: string): void => {
        if (!parentEl.previousElementSibling) {
            return;
        }

        parentEl.classList.remove(MAIN_NAV_ACTIVE_CLASS);
        parentEl.setAttribute('aria-expanded', 'false');
        const prevLinkEl = parentEl.previousElementSibling.querySelector(`.${focusElClass}`);
        if (!prevLinkEl) {
            return;
        }

        (prevLinkEl as HTMLAnchorElement).focus();
        parentEl.previousElementSibling.classList.add(MAIN_NAV_ACTIVE_CLASS);
        parentEl.previousElementSibling.setAttribute('aria-expanded', 'true');
    };

    const focusChildElement = (parentEl: HTMLElement, focusElClass: string): void => {
        const nextLinkEl = parentEl.querySelector(`.${focusElClass}`);
        if (!nextLinkEl) {
            return;
        }

        (nextLinkEl as HTMLAnchorElement).focus();
        nextLinkEl.parentElement?.classList.add(MAIN_NAV_ACTIVE_CLASS);
        nextLinkEl.parentElement?.setAttribute('aria-expanded', 'true');
    };

    const focusParentElement = (parentEl: HTMLElement, focusElClass: string): void => {
        const mainNavEl = parentEl.closest(`.${MEGA_MENU_ITEM_CLASS}`);

        if (!mainNavEl) {
            return;
        }

        parentEl.setAttribute('aria-expanded', 'false');
        parentEl.classList.remove(MAIN_NAV_ACTIVE_CLASS);

        const nextLinkEl = mainNavEl.querySelector(`.${focusElClass}`);
        if (!nextLinkEl) {
            return;
        }

        (nextLinkEl as HTMLAnchorElement).focus();
        // nextLinkEl.parentElement?.classList.add(MAIN_NAV_ACTIVE_CLASS);
    };

    const onMainLinkKeyDown = (e: KeyboardEvent): void => {
        const linkEl = e.target as HTMLElement;
        const { key } = e as KeyboardEvent;
        const parentEl: HTMLElement | null = linkEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
        if (!parentEl) {
            return;
        }

        /* eslint-disable indent */
        switch (key) {
            case 'ArrowDown': {
                e.preventDefault();
                closeAllNav();
                openMainNav(linkEl);
                break;
            }

            case 'ArrowUp': {
                e.preventDefault();
                closeMainNav(linkEl);
                break;
            }

            case 'ArrowRight': {
                e.preventDefault();
                closeAllNav();
                focusNextElement(parentEl, MAIN_NAV_ITEM_LINK_CLASS);
                break;
            }

            case 'ArrowLeft': {
                e.preventDefault();
                closeAllNav();
                focusPrevElement(parentEl, MAIN_NAV_ITEM_LINK_CLASS);
                break;
            }

            case 'Escape': {
                closeAllNav();
                // closeMainNav(linkEl);
                break;
            }

            default:
        }
        /* eslint-enable indent */
    };

    const onSubNavLinkKeyDown = (e: KeyboardEvent, subNavItemClass: string, subNavItemLinkClass: string): void => {
        const linkEl = e.target as HTMLElement;
        const { key } = e;
        const parentEl: HTMLElement | null = linkEl.closest(`.${subNavItemClass}`);
        if (!parentEl) {
            return;
        }

        /* eslint-disable indent */
        switch (key) {
            case 'ArrowDown': {
                e.preventDefault();
                focusNextElement(parentEl, subNavItemLinkClass);
                break;
            }

            case 'ArrowUp': {
                e.preventDefault();
                if (parentEl.previousElementSibling) {
                    focusPrevElement(parentEl, subNavItemLinkClass);
                } else {
                    // If goes from subnav to parent nav then set focus to parent
                    const mainNavEl = parentEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
                    if (!mainNavEl) {
                        return;
                    }

                    const mainNavLinkEl = mainNavEl.querySelector(`.${MAIN_NAV_ITEM_LINK_CLASS}`);
                    if (!mainNavLinkEl) {
                        return;
                    }

                    (mainNavLinkEl as HTMLAnchorElement).focus();
                }
                break;
            }

            case 'ArrowRight': {
                e.preventDefault();
                focusChildElement(parentEl, MEGA_MENU_SUB_NAV_ITEM_LINK_CLASS);
                break;
            }

            case 'ArrowLeft': {
                e.preventDefault();
                focusParentElement(parentEl, MEGA_MENU_ITEM_LINK_CLASS);
                break;
            }

            case 'Escape': {
                closeMainNav(linkEl);
                break;
            }

            default:
        }
        /* eslint-enable indent */
    };

    // if the user touches another part of the site close the util
    window.addEventListener('mouseup', e => {
        if (e.target && el !== e.target && !el.contains(e.target as HTMLElement) && !(e.target as HTMLElement).closest(MAIN_NAV_DATA_TAG)) {
            closeAllNav();
            closeAllSubNav();
        }
    });

    // disable scrolling while the mouse is over the mega menu
    // window.addEventListener('mouseover', e => {
    //     const target = (e.target as HTMLElement);
    //     if (target.closest(`.${MEGA_MENU_CLASS}`)) {
    //         ToggleScroll(true);
    //     } else {
    //         ToggleScroll(false);
    //     }
    // }, { passive: false });

    mainNavLinkEls.forEach(mainNavLinkEl => {
        // mainNavLinkEl.setAttribute('aria-expanded', 'false');
        mainNavLinkEl.addEventListener('keydown', (e => {
            onMainLinkKeyDown(e as KeyboardEvent);
        }));

        const parentEl = mainNavLinkEl.closest(`.${MAIN_NAV_ITEM_CLASS}`);
        if (!parentEl) {
            return;
        }

        mainNavLinkEl.addEventListener('click', (e => {
            // fix unclick-able primary nav without submenu
            // the issue come on desktop touchscreen ( laptop with touchscreen )
            if (!isHasSubmenu(parentEl as HTMLElement)) {
                return;
            }

            e.preventDefault();

            closeAllSubNav();
            if (parentEl.classList.contains(MAIN_NAV_ACTIVE_CLASS)) {
                closeMainNav(mainNavLinkEl as HTMLAnchorElement);
            } else {
                closeAllMainNav();
                openMainNav(mainNavLinkEl as HTMLElement);
            }
        }));
    });

    // subNavLinkEls.forEach(subNavLinkEl => {
    //     subNavLinkEl.addEventListener('keydown', (e => {
    //         onSubNavLinkKeyDown(e as KeyboardEvent, SUB_NAV_ITEM_CLASS, SUB_NAV_ITEM_LINK_CLASS);
    //     }));
    // });

    megaMenuLinkEls.forEach(megaMenuLinkEl => {
        megaMenuLinkEl.addEventListener('keydown', (e => {
            onSubNavLinkKeyDown(e as KeyboardEvent, MEGA_MENU_ITEM_CLASS, MEGA_MENU_ITEM_LINK_CLASS);
        }));

        const parentEl = megaMenuLinkEl.closest(`.${MEGA_MENU_ITEM_CLASS}`);

        parentEl?.addEventListener('mouseenter', (e => {
            closeAllMegaMenuNav();
            openMegaMenuNav(e.target as HTMLElement);
        }));
    });


    megaMenuSubNavEls.forEach(megaMenuLinkEl => {
        megaMenuLinkEl.addEventListener('keydown', (e => {
            onSubNavLinkKeyDown(e as KeyboardEvent, MEGA_MENU_SUB_NAV_ITEM_CLASS, MEGA_MENU_SUB_NAV_ITEM_LINK_CLASS);
        }));
    });


    outFocusEls.forEach(outFocusEl => {
        outFocusEl.addEventListener('focus', () => {
            closeAllNav();
        });
    });

    const windowResizeCheck = (): void => {
        megaMenuMainNavEls.forEach(megaMenuMainNavEl => {
            const subNavs = megaMenuMainNavEl.querySelectorAll(`.${MEGA_MENU_SUB_NAV_CLASS}`);
            const subNavHeightArray: number[] = [];

            subNavs.forEach(subNav => {
                const subNavHeight = getHiddenHeight(subNav as HTMLDivElement);
                subNavHeightArray.push(subNavHeight);
            });

            const maxHeight = Math.max(...subNavHeightArray);

            (megaMenuMainNavEl as HTMLDivElement).style.minHeight = `${maxHeight}px`;
        });

        closeAllMainNav();
    };

    const windowScrollCheck = (): void => {
        // closeAllMainNav();
    };

    windowResizeCheck();

    window.addEventListener('resize', debounce(windowResizeCheck, DEBOUNCE_VALUE));
    window.addEventListener('scroll', debounce(windowScrollCheck, DEBOUNCE_VALUE));
};

export default MainNav;
